import React from 'react';
import PropTypes from 'prop-types';
import {observable, action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';

@observer
export class StickyWrapper extends React.Component {

  static propTypes = {
    children: PropTypes.node,
    stickyStart: PropTypes.number,
    stickyEnd: PropTypes.number
  };

  @observable isElementSticky = false;
  @action makeElementSticky(stickyBool = true){
    this.isElementSticky = stickyBool;
  }

  constructor(props) {
    super(props);
    makeObservable(this);
    this.stickyElements = [];
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const setInitialDimensions = (elements) => {
      elements.forEach((sticky) => {
        sticky.setAttribute('sticky-init', sticky.getBoundingClientRect().top);
        //need to add width here so that it doesn't collapse when becoming position:fixed
        sticky.style.width = sticky.offsetWidth + 'px';
        sticky.style.left = sticky.getBoundingClientRect().left + 'px';
      });
    };

    this.stickyElements = Array.from(document.querySelectorAll('.sticky-wrapper'));
    setInitialDimensions(this.stickyElements);

    document.addEventListener('scroll', this.onStickyScroll, false);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onStickyScroll, false);
  }

  onStickyScroll = () => {
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    const bottom = document.documentElement.scrollHeight || document.body.scrollHeight;

    this.stickyElements.forEach((sticky) => {
      let stickyInitial = parseInt(sticky.getAttribute('sticky-init'), 10);
      let stickyEnter = parseInt(sticky.getAttribute('sticky-start'), 10) || stickyInitial;
      let stickyExit = parseInt(sticky.getAttribute('sticky-end'), 10) || bottom;

      if(top >= stickyEnter && top <= stickyExit) {
        this.makeElementSticky();
      } else {
        this.makeElementSticky(false);
      }
    });
  }


  render() {
    return (
      <div
        className={`sticky-wrapper ${this.isElementSticky ? 'sticky' : ''}`}
        sticky-start={this.props.stickyStart}
        sticky-end={this.props.stickyEnd}
        >
        {this.props.children}
      </div>
    )
  }

}
